export default {
  isJson (item) {
    item = typeof item !== 'string' ? JSON.stringify(item) : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === 'object' && item !== null) {
      return true;
    }

    return false;
  },

  moveArray (arr, oldIndex, newIndex) {
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
  },

  ModifyArrayAfterSaveEditedItem (localElements, newElementFromBD, Id) {
    var newCollection = [];

    localElements.map(p => {
      if (p.id === Id) {
        let aux = p;
        let keys = Object.keys(newElementFromBD);
        keys.map(e => {
          aux[e] = newElementFromBD[e];
        });

        newCollection.push(aux);
      } else newCollection.push(p);
    });

    return newCollection;
  },
  ModifyArrayAfterSaveItem (localElements, newElement) {
    var newCollection = [];
    if (localElements.length > 0) {
      localElements.forEach(p => {
        newCollection.push(p);
      });
    }
    newCollection.push(newElement);
    return newCollection;
  },

  convertHexToRGBA (hexCode, opacity = 1) {
    let hex = hexCode.replace('#', '');

    if (hex.length === 3) {
      hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    /* Backward compatibility for whole number based opacity values. */
    if (opacity > 1 && opacity <= 100) {
      opacity = opacity / 100;
    }

    return `rgba(${r},${g},${b},${opacity})`;
  },

  diffArray (a, b) {
    var makeSymmDiffFunc = (function () {
      var contains = function (pred, a, list) {
        var idx = -1; var len = list.length;
        while (++idx < len) { if (pred(a, list[idx])) { return true; } }
        return false;
      };
      var complement = function (pred, a, b) {
        return a.filter(function (elem) { return !contains(pred, elem, b); });
      };
      return function (pred) {
        return function (a, b) {
          return complement(pred, a, b).concat(complement(pred, b, a));
        };
      };
    }());

    var myDiff = makeSymmDiffFunc(function (x, y) {
      let keys = Object.keys(x);
      let concat = '';
      for (let i = 0; i < keys.length; i++) {
        i !== keys.length ? concat = x[keys[i]] === y[keys[i]] + '&&' : concat = x[keys[i]] === y[keys[i]];
      }
      return concat;
    });

    return myDiff(a, b);
  }
};
